<ng-container *transloco="let _t">

<h3>{{ _t('rm-preco-h3-0') }}</h3>
<div class="preco" [innerHtml]="preco.preco"></div>
<div class="text-right">
	<br>
	<button (click)="dialogRef.close()">{{ _t('Fermer') }}</button>
</div>

</ng-container>